module.exports = __webpack_public_path__ + "img/01_LOGO.1037864f.png";